import {AnyAction} from 'redux'
import {crudReducer, CrudState, initialCrudState} from 'lib/crud'

export const name = 'GROUP_CLASS'

export type GroupClassState = {
    crud: CrudState,
}

const initialState = {
    crud: initialCrudState,
}

export function groupClassReducer(state: GroupClassState = initialState, action: AnyAction): GroupClassState {
    switch (action.type) {
        default:
            return {
                ...state,
                crud: crudReducer(name, state.crud, action)
            }
    }
}
